module.exports = __webpack_public_path__ + "static/media/AvatarWalter.df8a91ea.png";